module.exports = __webpack_public_path__ + "static/flame-background-986cfcf82d8898b0976751f082e627f3.png";